import React from "react";

interface MiscPlayerAgeProps {
  age: number;
  retirementYears: number;
  compact?: boolean;
}

const MiscPlayerAge: React.FC<MiscPlayerAgeProps> = ({ age, retirementYears, compact = false }) => {
  const tooltip =
    retirementYears === 0
      ? "Player has retired"
      : `Player will retire in ${retirementYears} season${retirementYears > 1 ? "s" : ""}`;

  const color =
    retirementYears === 3
      ? "rgb(255, 204, 0)"
      : retirementYears === 2
      ? "rgb(255, 153, 0)"
      : retirementYears === 1
      ? "rgb(255, 0, 0)"
      : retirementYears === 0
      ? "rgb(100, 100, 100)"
      : undefined;

  if (compact) {
    return (
      <span
        title={color ? tooltip : undefined}
        style={{ color, textDecoration: retirementYears === 0 ? "line-through" : "none" }}
      >
        {age}
      </span>
    );
  }

  return (
    <div
      title={tooltip}
      style={{
        width: "50px",
        textDecoration: retirementYears === 0 ? "line-through" : "none",
        cursor: "default",
      }}
    >
      <i
        className="bi bi-cake2-fill me-1"
        style={{
          color,
        }}
      />
      {age}
    </div>
  );
};

export default MiscPlayerAge;
